import React, { lazy } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CheckCircle2Icon, LockIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { CHECKOUT_URL, MAIN_IMG, BONUS_IMGS } from '../utils/constants';
import { PaymentBadges } from './PaymentBadges';
export function OfferSection() {
  const savings = [{
    item: 'Mega-Pack Educazione Fisica (5 libri)',
    value: '49,99 €'
  }, {
    item: '50 Giochi Veloci per Educazione Fisica',
    value: '9,99 €',
    free: true
  }, {
    item: '30 Lezioni Complete di Educazione Fisica',
    value: '12,99 €',
    free: true
  }, {
    item: 'Schede di Valutazione Pronte da Stampare',
    value: '7,99 €',
    free: true
  }, {
    item: '40 Percorsi Motori Creativi',
    value: '9,99 €',
    free: true
  }];
  const totalValue = '90,95 €';
  return <section id="oferta" className="py-20 px-4 bg-gradient-to-b from-gray-50 to-white scroll-mt-20" data-id="element-137">
      <div className="max-w-4xl mx-auto" data-id="element-138">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-green-500 relative" data-id="element-139">
          <div className="bg-green-500 text-white text-center py-4" data-id="element-140">
            <h2 className="text-2xl font-bold uppercase tracking-wider" data-id="element-141">
              Accedi Ora al Mega-Pack
            </h2>
          </div>

          <div className="p-6 md:p-10" data-id="element-142">
            <div className="flex items-end justify-center gap-1 mb-8" data-id="element-143">
              <img src={BONUS_IMGS[0]} alt="Bonus 1" loading="lazy" className="w-[14%] rounded-md shadow-md transform -rotate-6" data-id="element-144" />
              <img src={BONUS_IMGS[1]} alt="Bonus 2" loading="lazy" className="w-[16%] rounded-md shadow-lg transform -rotate-3" data-id="element-145" />
              <img src={MAIN_IMG} alt="Mega-Pack" loading="lazy" className="w-[22%] rounded-lg shadow-xl z-10" data-id="element-146" />
              <img src={BONUS_IMGS[2]} alt="Bonus 3" loading="lazy" className="w-[16%] rounded-md shadow-lg transform rotate-3" data-id="element-147" />
              <img src={BONUS_IMGS[3]} alt="Bonus 4" loading="lazy" className="w-[14%] rounded-md shadow-md transform rotate-6" data-id="element-148" />
            </div>

            <div className="bg-gray-50 rounded-2xl p-6 mb-8 border border-gray-100" data-id="element-149">
              <h3 className="text-lg font-bold text-gray-900 mb-4 text-center" data-id="element-150">
                Ecco tutto quello che ricevi oggi:
              </h3>
              <div className="space-y-3" data-id="element-151">
                {savings.map((s, idx) => <div key={idx} className="flex items-center justify-between gap-3" data-id="element-152">
                    <div className="flex items-center gap-2 flex-1 min-w-0" data-id="element-153">
                      <CheckCircle2Icon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-154" />
                      <span className="text-sm text-gray-700 truncate" data-id="element-155">
                        {s.item}
                      </span>
                      {s.free && <span className="bg-red-100 text-red-600 text-xs font-bold px-2 py-0.5 rounded flex-shrink-0" data-id="element-156">
                          GRATIS
                        </span>}
                    </div>
                    <span className={`text-sm font-medium flex-shrink-0 ${s.free ? 'text-gray-400 line-through' : 'text-gray-700'}`} data-id="element-157">
                      {s.value}
                    </span>
                  </div>)}
              </div>
              <div className="border-t border-gray-200 mt-4 pt-4 flex items-center justify-between" data-id="element-158">
                <span className="font-bold text-gray-900" data-id="element-159">Valore totale:</span>
                <span className="font-bold text-gray-400 line-through text-lg" data-id="element-160">
                  {totalValue}
                </span>
              </div>
            </div>

            <div className="text-center" data-id="element-161">
              <div className="mb-2" data-id="element-162">
                <p className="text-gray-500 text-base font-medium" data-id="element-163">
                  Prezzo originale:
                </p>
                <p className="text-2xl text-gray-400 line-through decoration-red-500 decoration-2 font-bold" data-id="element-164">
                  49,99 €
                </p>
              </div>

              <div className="mb-6" data-id="element-165">
                <p className="text-green-600 font-bold text-lg mb-1" data-id="element-166">
                  Prezzo speciale oggi:
                </p>
                <p className="text-5xl md:text-6xl font-extrabold text-gray-900" data-id="element-167">
                  15,99 <span className="text-xl text-gray-500" data-id="element-168">€</span>
                </p>
                <p className="text-green-600 font-bold text-sm mt-2" data-id="element-169">
                  Risparmi oltre il 70%!
                </p>
              </div>

              <div className="mb-6" data-id="element-170">
                <div className="flex justify-center mb-3" data-id="element-171">
                  <CountdownTimer data-id="element-172" />
                </div>
                <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block w-full max-w-md mx-auto bg-green-600 hover:bg-green-500 text-white font-bold text-2xl py-6 px-8 rounded-2xl shadow-[0_10px_40px_rgb(22,163,74,0.4)] hover:shadow-[0_10px_40px_rgb(22,163,74,0.6)] transform hover:-translate-y-1 transition-all duration-300 animate-pulse-fast text-center" data-id="element-173">
                  ACQUISTA ORA
                </a>
              </div>

              {/* Enhanced Trust & Security Elements */}
              <div className="max-w-md mx-auto" data-id="element-174">
                <PaymentBadges className="mb-4" data-id="element-175" />

                <div className="bg-green-50 border border-green-100 rounded-xl p-4 mb-4 text-left" data-id="element-176">
                  <div className="flex items-start gap-3 mb-3" data-id="element-177">
                    <LockIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-178" />
                    <div data-id="element-179">
                      <p className="text-sm font-bold text-gray-900" data-id="element-180">
                        Transazione Sicura al 100%
                      </p>
                      <p className="text-xs text-gray-600" data-id="element-181">
                        Protetto con crittografia SSL a 256 bit.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 mb-3" data-id="element-182">
                    <ShieldCheckIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-183" />
                    <div data-id="element-184">
                      <p className="text-sm font-bold text-gray-900" data-id="element-185">
                        Garanzia 45 Giorni
                      </p>
                      <p className="text-xs text-gray-600" data-id="element-186">
                        Soddisfatti o rimborsati. Nessun rischio.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-187">
                    <CreditCardIcon className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-188" />
                    <div data-id="element-189">
                      <p className="text-sm font-bold text-gray-900" data-id="element-190">
                        Pagamento Unico
                      </p>
                      <p className="text-xs text-gray-600" data-id="element-191">
                        Nessun abbonamento. Nessun costo nascosto.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Post-purchase steps */}
                <div className="bg-gray-50 rounded-xl p-4 text-left border border-gray-200" data-id="element-192">
                  <p className="text-sm font-bold text-gray-900 mb-3 text-center" data-id="element-193">
                    Cosa succede dopo l&apos;acquisto?
                  </p>
                  <ol className="space-y-2" data-id="element-194">
                    <li className="flex gap-2 text-sm text-gray-700" data-id="element-195">
                      <span className="font-bold text-blue-600" data-id="element-196">1.</span>
                      Completa il pagamento sicuro
                    </li>
                    <li className="flex gap-2 text-sm text-gray-700" data-id="element-197">
                      <span className="font-bold text-blue-600" data-id="element-198">2.</span>
                      Ricevi l&apos;email con il link di download
                    </li>
                    <li className="flex gap-2 text-sm text-gray-700" data-id="element-199">
                      <span className="font-bold text-blue-600" data-id="element-200">3.</span>
                      Scarica e inizia subito a usare i materiali
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}